import React, { useEffect,useState } from 'react'
import useAuth from "../../../../customHooks/useAuth";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PageLoader from "../../../components/PageLoader/PageLoader";
import axiosInstance from '../../../../axiosInstance/axiosInstance';


export default function UpdateWebCheckIntags() {
    
    useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    // Necessary Data
    const bookingId = location.state?.bookingId || "";
    const userId = localStorage.getItem("user_id");
    const hotelId = location.state?.hotelId || ""; 

    const checkInDate = location.state?.checkInDate || "";
    const checkOutDate = location.state?.checkOutDate || "";
 

    const guests = location.state?.guests || [];
    const bookedRooms = location.state?.bookedRooms || [];

    const tagItems = location.state?.tags || [];


    const [isLoading,setIsLoading] = useState(false);
    const timeArrival = location.state?.timeArrival || "";


    const sections = [
        {
            title: "Purpose of stay",
            options: [
            "Leisure/Wellness Vacation",
            "Honeymoon",
            "Anniversary",
            "Birthday Celebration",
            "Family Vacation",
            "Friends Trip",
            "Workcation",
            "Corporate Offsite",
            "Adventure Trip",
            "Spiritual Retreat",
            ],
        },
        {
            title: "Travelling with",
            options: [
            "Solo",
            "Couple",
            "Family",
            "Friends",
            "Colleagues",
            "Kids",
            "Pets",
            ],
        },
        {
            title: "Dietary preferences",
            options: [
            "Vegetarian",
            "Eggetarian",
            "Vegan",
            "Jain",
            "Non-Vegetarian",
            ],
        },
        {
            title: "Arrival preference",
            label: "Arriving by",
            options: [
            "Self drive",
            "Cab",
            "Bus",
            "Flight",
            "Train",
            ],
        },
        {
            title: "Interests during stay",
            options: [
            "Adventure sports",
            "Trekking & Hiking",
            "Local Tours",
            "Local Arts",
            "Wildlife",
            "Local shopping",
            "Couple outings",
            "Off beat locations",
            "Family outings",
            ],
        },
    ];



    const handleTagClick = (sectionTitle, option) => {
        try {
            setSelectedTags((prev) => {
                if (sectionTitle === "Arrival preference") {
                    const current = prev[sectionTitle] || [];

                    return {
                        ...prev,
                        [sectionTitle]: current.includes(option) ? [] : [option],
                    };
                }

                const current = prev[sectionTitle] || [];

                const updated = current.includes(option)
                    ? current.filter((item) => item !== option)
                    : [...current, option];

                return {
                    ...prev,
                    [sectionTitle]: updated,
                };
            });
        } catch (error) {
            console.log(error);
        }
    };

   

    const checkInSubmit = async () => {
        try {
            setIsLoading(true);
            
    
            const formatSelectedTags = (selectedTags) => {
                const formatted = {
                    purpose: [],
                    travelling_with: [],
                    dietary: [],
                    interests: [],
                    arrival: "",
                };

                Object.entries(selectedTags).forEach(([key, value]) => {
                    switch (key) {
                        case "Purpose of stay":
                            formatted.purpose = value;
                            break;

                        case "Travelling with":
                            formatted.travelling_with = value;
                            break;

                        case "Arrival preference":
                            formatted.arrival = value.length ? value[0] : "";
                            break;

                        case "Dietary preferences":
                            formatted.dietary = value;
                            break;

                        case "Interests during stay":
                            formatted.interests = value;
                            break;

                        default:
                            break;
                    }
                });

                return formatted;
            };
            console.log("selectedTags", selectedTags);
            const formattedTags = formatSelectedTags(selectedTags);
       
            // Add booked_room_id to each guest
            const updatedGuests = guests.flatMap((roomGuests, roomIndex) => {
                const bookedRoomId = bookedRooms[roomIndex]?.booked_room_id || "";

                return roomGuests.map((guest) => ({
                    ...guest,
                    booked_room_id: bookedRoomId,
                }));
            });

            const passData = {
                checkin_date: checkInDate,
                checkout_date: checkOutDate,
                ...formattedTags,
                arrival_time: timeArrival || "",
                guests: updatedGuests,
                number_of_guests : updatedGuests?.length || 0
            };
            const response = await axiosInstance.put(
                `/api/v1/users/${userId}/bookings/${bookingId}/web-checkin`,
                passData
            );

            toast.success("WebCheckIn for added guests, updated successfully");
                navigate("/webCheckinSuccess", {
                state: {
                    guests: updatedGuests,
                },
            });
 
        } catch (error) {
            toast.error(error?.response?.data?.message || "Some Error Occured");
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
 

    // Check If Booking Id and HotelId are there or not
    useEffect(()=>{
        const checkData = ()=>{
            if(bookingId==="" || hotelId===""){
            navigate("/bookings");
            }
        }
        checkData();
    },[bookingId,hotelId,navigate]);


    const formatApiTags = (tags) => ({
        "Purpose of stay": tags?.purpose || [],
        "Travelling with": tags?.travelling_with || [],
        "Dietary preferences": tags?.dietary || [],
        "Interests during stay": tags?.interests || [],
        "Arrival preference": tags?.arrival ? [tags.arrival] : [],
    });

    // Stores selected options for each section
    const initialTags =
    tagItems?.purpose !== undefined
        ? formatApiTags(tagItems) // API response
        : tagItems;               // Already formatted

    const [selectedTags, setSelectedTags] = useState(initialTags);
 
 
   
    const moveToCheckin = ()=>{
        try{
            navigate("/updateWebCheckin",
                {
                    state : {
                        hotelId,
                        bookingId,
                        checkInDate,
                        checkOutDate,
                        guests,
                        bookedRooms : bookedRooms,
                        tagData : selectedTags,
                        timeArrival
                    }
                }
            )
        }catch(error){
            console.log(error);
        }

    }


  return (
    <>
        {
            isLoading && <PageLoader/>
        }
        <div className="webcheckin-tags">
            {/* Header */}
            <div className="personalize-header">
                <div className="header-content">
                <button className="back-btn" onClick={()=>moveToCheckin()}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M15 5l-7 7 7 7"
                        stroke="currentColor"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    </svg>
                </button>

                <div className="header-text">
                    <h2>Personalise your stay</h2>
                    <p>Step 2 of 2 · Optional · skip anytime</p>
                </div>

                <div className="progress">
                    <span className="active"></span>
                    <span className="active"></span>
                </div>
                </div>
            </div>

            {/* Content */}
            <div className="personalize-body">
                <p className="intro">
                A few optional details so we can tailor your stay.
                <strong> Skip anytime</strong> — your check-in is already done.
                </p>

                {sections.map((section) => (
                <div className="section" key={section.title}>
                    <h3>{section.label || section.title}</h3>

                    <div className="options">
                    {section.options.map((item) => {
                        const isSelected =
                        selectedTags[section.title]?.includes(item);

                        return (
                        <button
                            key={item}
                            className={`option-btn ${isSelected ? "active" : ""}`}
                            onClick={() =>
                            handleTagClick(section.title, item)
                            }
                        >
                            {item}
                        </button>
                        );
                    })}
                    </div>
                </div>
                ))}
            </div>

            {/* Footer */}
            <div className="personailize-footer-actions">
                <div className="personailize-footer-buttons">
                    <div className="personailize-skip-wrapper">
                        <button className="personailize-skip-button" onClick={()=>checkInSubmit()}>
                            Skip
                        </button>
                    </div>
                    <div className="personailize-save-wrapper">
                        <button className="personailize-save-button" onClick={()=>checkInSubmit()}>
                            Save &amp; finish
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </>
  )
}
